import React from 'react'

import './styles.scss'

const baseClass = 'dashboard-top-loader'

const CompanyDashboardTopLoader = () => (
  <div className={`${baseClass}`}>
    <div className={`${baseClass}__section`}>
      <div
        className="loader-row"
        style={{
          width: '30px',
          height: '20px',
          marginBottom: '20px',
        }}
      />
      <div className={`${baseClass}__content`}>
        <div className={`${baseClass}__sub-section`}>
          <div
            className="loader-row"
            style={{
              width: '49px',
              height: '20px',
              marginBottom: '5px',
            }}
          />
          <div
            className="loader-row"
            style={{
              width: '168px',
              height: '20px',
            }}
          />
        </div>
        <div className={`${baseClass}__sub-section`}>
          <div
            className="loader-row"
            style={{
              width: '54px',
              height: '20px',
              marginBottom: '5px',
            }}
          />
          <div
            className="loader-row"
            style={{
              width: '120px',
              height: '20px',
              marginBottom: '5px',
            }}
          />
          <div
            className="loader-row"
            style={{
              width: '75px',
              height: '20px',
            }}
          />
        </div>
      </div>
    </div>
  </div>
)

export default CompanyDashboardTopLoader
